import { KeyValue } from 'ngrx-forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { map } from 'rxjs';

import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import {
  LazyEntityFacadeInterface,
  RouterFacadeInterface,
} from '@ideapa/app-common';
import { BaseDto } from '@ideapa/common-dto';

export abstract class BaseListGuard<T extends BaseDto, K extends KeyValue>
  implements CanActivate
{
  constructor(
    // sharedFacade: SharedFacade,
    protected facade: LazyEntityFacadeInterface<T, K>,
    private routerFacade: RouterFacadeInterface,
    permissionsService: NgxPermissionsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.facade.entityId$.pipe(
      map((id) => {
        if (id != null) {
          this.routerFacade.navigateRelative([state.url, id], undefined, null);
          return false;
        }
        return true;
      })
    );
  }
}
